/**
 * Filters menu items based on global preferences.
 * Any menu item or group with a `pref` key is hidden when that preference is false.
 */
export function filterMenuByPrefs(menuItems, prefs) {
  if (!prefs) return menuItems;

  return menuItems.map((section) => {
    if (!section.children) return section;
    return {
      ...section,
      children: section.children
        .map((group) => {
          if (!group.children) {
            if (group.pref && prefs[group.pref] && !prefs[group.pref].value)
              return null;
            return group;
          }
          const filteredChildren = group.children.filter((child) => {
            if (child.pref && prefs[child.pref] && !prefs[child.pref].value)
              return false;
            return true;
          });
          if (filteredChildren.length === 0) return null;
          return { ...group, children: filteredChildren };
        })
        .filter(Boolean),
    };
  });
}
